<template>
  <div class="account">
    <div class="content">
      <span>{{content}}</span>
      <img src="../../assets/images/new-login-2018/Group Copy 4.png" @click="clickIcon">
    </div>
  </div>
</template>

<script>
  import config from '@/assets/js/config'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  export default {
    data () {
      return {
      }
    },
    props: ['type', 'content'],
    mounted () {
    },
    methods: {
      clickIcon () {
        if (!config.isLogin) {
          // 埋点统计：邀请页面点击切换账号
          uploadWebEvent('INVITE_SWITCH_BACK', {
            type: this.type
          })
        }
        if (config.isLogin && (this.$route.path === '/' || this.$route.path === '/login/signin')) {
          this.$emit('showPassword', false)
        } else {
          history.back()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
	.account {
    width: 100%;
    height: 25px;
    margin-top: 30px;
    .content {
      width: 300px;
      height: 25px;
      display: inherit;
      margin: 0 auto;
      padding: 0 10px;
      span {
        color: #3e3e3e;
        line-height: 25px;
        float: left;
      }
      img {
        width: 24px;
        height: 24px;
        float: right;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Account.vue?3b4780b8